import * as React from 'react';
import { StyledProps } from '@front10';
import { useTranslation } from '@front10/utils';
import LocationSelector from '../../controls/LocationSelector';

interface Props {
  labelKey: string;
  placeholderKey?: string;
  value: string;
  options: unknown[];
  menuItem?: $TSFixMe;
  inputItem?: $TSFixMe;
  listItem?: $TSFixMe;
  groupItem?: $TSFixMe;
  noResultItem?: $TSFixMe;
  loadingMessage?: $TSFixMe;
  onChange: $TSFixMe;
  onInputChange: $TSFixMe;
  hasError: boolean;
  inputFocusReferences: React.Ref<$TSFixMe>;
  dataTestId?: string;
  onClear: $TSFixMe;
  loading: boolean;
}

export function AutoComplete({
  placeholderKey = 'cmp-bus-directory-map-selector-placeholder',
  menuItem,
  inputItem,
  listItem,
  groupItem,
  noResultItem,
  loadingMessage,
  value,
  ...props
}: StyledProps<Props>) {
  const translate = useTranslation();
  return (
    <LocationSelector
      charactersAllowed="all"
      flexGrow="1"
      showLoadingMessage={true}
      showSelectorMenuArrow={false}
      showLabelInside={false}
      clearable={true}
      grouped={true}
      showCode={false}
      searchInside={false}
      showArrowsIfClearable={false}
      showArrows={false}
      menuItem={{
        shadow: '4',
        paddingHeight: '0',
        rounded: '0',
        border: true,
        ...menuItem
      }}
      inputItem={{
        shadow: '@theme:input.shadow',
        rounded: '@theme:input.rounded',
        ...inputItem
      }}
      listItem={{
        hoverBgColor: 'danger',
        hoverTextColor: 'white',
        paddingLeft: '4',
        paddingRight: '1',
        paddingHeight: '2',
        ...listItem
      }}
      groupItem={{
        bgColor: 'dark-2',
        textColor: 'dark',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        paddingWidth: '1',
        paddingHeight: '2',
        ...groupItem
      }}
      noResultItem={{
        paddingWidth: '1',
        paddingHeight: '2',
        ...noResultItem
      }}
      loadingMessage={{
        paddingLeft: '5',
        fontWeight: 'bold',
        ...loadingMessage
      }}
      placeholder={translate(placeholderKey, 'Type state, city, zip code')}
      {...props}
      defaultValue={value}
    />
  );
}
